import Bugsnag from '@bugsnag/js';

export function reportToBugsnag(error, context = {}) {
    const config = error?.config || {};
    const response = error?.response || {};

    const method = (config.method || 'UNKNOWN').toUpperCase();
    const url = config.url || 'unknown endpoint';
    const status = response.status || 'N/A';
    const statusText = response.statusText || response.data || 'Unknown error';

    const formatted = `[${status}] [${method}] ${url}: ${statusText}`;
    const customError = new Error(formatted);

    Bugsnag.notify(customError, event => {
        event.addMetadata('axios', {
            url,
            method,
            status,
            statusText,
            requestData: config.data,
            headers: config.headers,
            params: config.params,
            responseData: response.data,
            originalMessage: error?.message,
            ...context.meta,
        });

        if (context.severity) {
            event.severity = context.severity;
        }
    });
}

export async function withErrorReporting(promiseFn, context = {}) {
    try {
        return await promiseFn();
    } catch (error) {
        reportToBugsnag(error);
        throw error;
    }
}
